import React, { useState, useEffect } from 'react'
import { Container, Top } from '../styles'
import { DefaultAdminPage } from '../../DefaultPages'

import { BoxCertificate, BoxContainer, BoxChooses } from './styles'
import { Search, InsideFooter, Breadcrumbs } from '../../../components'
import ecbrDNA from '../../../assets/Icons/ecbrDna.svg'
import { useQuery } from 'react-query'
import ecbrApi from '../../../services/ecbrApi'
import { useModal } from '../../../hooks/useModal'
import CertificateModal from './CertificateModal'
import useHistory from '../../../hooks/useHistory'

const Certificates = () => {
  const [renderModal, _openModal] = useModal(CertificateModal)
  const [error, setError] = useState('')
  const [searchParameters, setSearchParameters] = useState({
    name: ''
  })
  const history = useHistory()

  const {
    data: certificates,
    refetch,
    error: _error
  } = useQuery(
    'certificates',
    async () =>
      (await ecbrApi.products.getAll())?.data?.filter((product) =>
        product.name.toLowerCase().includes(searchParameters.name.toLowerCase())
      ),
    {
      cacheTime: 0,
      onSuccess: () => {
        setError('')
      },
      onError: () => {
        setError('Não foi possível carregar os dados')
      }
    }
  )

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParameters.name])

  const handleClickCertificate = (certificate) => {
    history.push(`/admin/certificates/${certificate.id}`)
  }

  const handleSearch = (value) => {
    setSearchParameters({
      ...searchParameters,
      name: value
    })
  }

  return (
    <DefaultAdminPage page="certificados">
      {renderModal}
      <Container>
        <Top>
          <Breadcrumbs />
          {/* <Button
            type="button"
            variant="outlined"
            text="Exportar excel"
            width="120px"
          /> */}
        </Top>
        <h3>
          Aqui você pode gerenciar todos os certificados cadastrados no sistema
        </h3>
        <BoxChooses>
          <Search
            placeholder="pesquisar certificado"
            onSearch={(value) => handleSearch(value)}
          />
        </BoxChooses>
        <BoxContainer>
          {error && <p>{error}</p>}
          {certificates?.map?.((certificate, key) => (
            <BoxCertificate
              key={key}
              onClick={() => handleClickCertificate(certificate)}
            >
              <div>
                <img src={ecbrDNA} alt="ecbrDNA" />
                <h3>{certificate.name}</h3>
              </div>
            </BoxCertificate>
          ))}
          {/* <BoxBrand isButton={true}>
            <div>
              <img
                src={plusIcon}
                alt="plusIcon"
                onClick={() => openModal({ onExited: () => refetch() })}
              />
            </div>
          </BoxBrand> */}
        </BoxContainer>
        <InsideFooter />
      </Container>
    </DefaultAdminPage>
  )
}

export default Certificates
